<template>
  <div class="bottom-fixed">
    <div v-show="!inputVisible" class="inner-flex inner-flex-dark">
      <div @click="triggerInput" class="input-trigger-container">
        <span>来都来了，唠个嗑呗~</span>
      </div>
      <div class="round-button-wrapper">
        <img @click="showProducts" class="round-button" src="/dg3/static/assets/bottom-products.png" />
        <div @click="goToOnsaleProduct" :class="{ 'show-product': onsaleVisible }" class="new-product-wrapper">
          <div class="new-product">
            <div class="new-product-cover">
              <img :src="onsale.imageListGoods | filterPicture" />
              <span class="new-product-cover-tag">{{ onsale.sort }}</span>
            </div>
            <div class="new-product-info">
              <p class="new-product-info-name two-line">{{ onsale.boldName + onsale.name }}</p>
              <div class="new-product-info-footer">
                <span v-if="['LUCKYBAG', 'VOUCHER'].indexOf(onsale.type) !== -1" class="new-product-info-price">¥{{ onsale.price | filterPrice }}</span>
                <span v-else></span>
                <van-icon name="shopping-cart-o" size="18" color="#999" />
              </div>
            </div>
          </div>
          <div class="new-product-triangle" />
        </div>
      </div>
      <div class="round-button-wrapper">
        <img @click="bubbleUp" class="round-button" src="/dg3/static/assets/bottom-like.png" />
        <div class="bubble-click-count">{{ parseInt(viewers * 1.3) }}</div>
        <canvas id="like-bubble-container" />
      </div>
      <div class="round-button-wrapper">
        <img @click="goToCoupons" class="round-button" src="/dg3/static/assets/bottom-coupons.png" />
      </div>
    </div>
    
    <div v-show="inputVisible" class="inner-flex inner-flex-light">
      <van-field ref="inputField" @blur="onInputBlur" v-model="value" class="input-container" placeholder="来都来了，唠个嗑呗~" maxlength="80" />
      <van-button @click="onSubmit" type="danger">发送</van-button>
    </div>

    <img @click="showCustomer" class="customer-btn" src="/dg3/static/assets/bottom-customer.png" />
    <div :class="'safe-area safe-area-' + (inputVisible ? 'light' : 'dark')" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getRandom } from '@/utils'

function requestFrame(cb) {
  return (
    window.requestAnimationFrame || window.webkitRequestAnimationFrame || function(callback) {
      window.setTimeout(callback, 1000 / 60)
    }
  )(cb)
}

export default {
  data () {
    return {
      inputVisible: false,
      value: '',

      context: '',
      canvasWidth: '',
      canvasHeight: '',
      renderList: [],
      bubbleImagesList: [],
      scanning: false
    }
  },

  computed: {
    ...mapState({
      clientWidth: (state) => state.clientWidth,
      onsale: (state) => state.products.onsale,
      onsaleVisible: (state) => state.products.onsaleVisible,
      viewers: (state) => state.room.viewers,
    })
  },

  mounted () {
    this.loadBubbleImages()  // 预先加载点赞所有素材

    // 初始化 canvas
    const canvas = document.getElementById('like-bubble-container')
    canvas.width = this.canvasWidth = this.clientWidth * .248
    canvas.height = this.canvasHeight = this.clientWidth * .46

    this.context = canvas.getContext('2d')
  },

  methods: {
    onSubmit () {
      if (this.value) {
        this.$store.dispatch('submitInput', this.value)
        this.value = ''
      }
    },

    triggerInput () {
      if (!this.inputVisible) {
        this.inputVisible = true
        this.$nextTick(() => {
          this.$refs.inputField.focus()
        })
      }
    },

    onInputBlur () {
      setTimeout(() => this.inputVisible = false, 200)
    },

    showProducts () {
      this.$store.commit('showProducts')
    },

    goToOnsaleProduct () {
      this.$emit('goToOnsaleProduct')
    },

    goToCoupons () {
      this.$router.push({ path: '/coupons' })
    },

    loadBubbleImages () {
      const promiseArray = []

      for (let i = 1; i <= 10; i ++) {
        promiseArray.push(
          new Promise((resolve) => {
            const image = new Image
            image.onerror = image.onload = resolve(image)
            image.src = '/dg3/static/assets/like/' + i + '.png'
            image.width = image.height = this.clientWidth * .1
          })
        )
      }

      Promise.all(promiseArray).then((imagesArray) => {
        this.bubbleImagesList = imagesArray.filter(item => item && item.width > 0)
      })
    },

    createBubbleRender () {
      if (!this.bubbleImagesList.length) return

      // 随机图片
      const randomImage = this.bubbleImagesList[getRandom(0, this.bubbleImagesList.length - 1)]

      // 处理 xy 轴
      const offset = 25
      const basicX = this.canvasWidth / 2 + getRandom(-offset, offset)
      const getTranslateY = (diffTime) => randomImage.height / 2 + (this.canvasHeight - randomImage.height / 2) * (1 - diffTime)

      // 旋转角度
      let ratio = getRandom(10, 30) * (getRandom(0, 1) ? 1 : -1)
      const rotate = getRandom(-45, 45)

      // 计算渐入渐出
      const fadeProgress = getRandom(10, 20)
      const fadeInProgress = fadeProgress * 2
      const fadeOutProgress = 100 - fadeProgress

      const getAlpha = (diffTime) => {
        const progress = parseInt(diffTime * 100)

        if (progress > fadeOutProgress) return (1 - (progress - fadeOutProgress) / fadeProgress).toFixed(2)
        else if (progress < fadeInProgress) return (progress  / fadeInProgress).toFixed(2)
        else return 1
      }

      return (diffTime) => {
        if(diffTime >= 1) return true
        this.context.save()
        this.context.translate(basicX, getTranslateY(diffTime))
        this.context.rotate(rotate * Math.PI / 180)
        this.context.globalAlpha = getAlpha(diffTime)
        this.context.drawImage(
          randomImage,
          -randomImage.width / 2,
          -randomImage.height / 2,
          randomImage.width,
          randomImage.height
        )
        this.context.restore()
      }
    },

    scan () {
      this.context.clearRect(0, 0, this.canvasWidth, this.canvasHeight)

      let index = 0
      let length = this.renderList.length

      if (length > 0) {
        requestFrame(this.scan)
        this.scanning = true
      } else {
        this.scanning = false
      }

      while (index < length) {
        const child = this.renderList[index]
        if (!child || !child.render || child.render.call(null, (Date.now() - child.timestamp) / child.duration)) {
          // 结束了，删除该动画
          this.renderList.splice(index, 1)
          length--
        } else {
          // continue
          index++
        }
      }
    },

    bubbleUp () {
      const render = this.createBubbleRender()
      const duration = getRandom(1200, 2000)
      this.renderList.push({ render, duration, timestamp: Date.now() })

      if (!this.scanning) {
        this.scanning = true
        requestFrame(this.scan)
      }

      return this
    },

    showCustomer () {
      this.$store.commit('changePopupVisible', { visible: true, status: 'code' })
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-fixed {
  position: fixed;
  bottom: 0;
  z-index: 100;
  width: 100%;

  .inner-flex {
    display: flex;
    align-items: center;
    padding: .2rem .24rem;
    height: 1.16rem;
  }
  .inner-flex.inner-flex-dark {
    background-color: #8308B7;
    // background-color: #320372;
    .input-trigger-container {
      flex: 1;
      display: flex;
      align-items: center;
      background-color: rgba(0, 0, 0, .3);
      border-radius: .38rem;
      color: #FFF;
      height: 100%;
      span {
        margin-left: .3rem;
      }
    }
    .round-button-wrapper {
      position: relative;
      margin-left: .2rem;
      .round-button {
        display: block;
        width: .76rem;
        height: 100%;
      }
      .new-product-wrapper {
        z-index: 102;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        top: -1.7rem;
        left: calc(-2.1rem + .38rem);
        transform: translateY(0) scale(.2);
        transform-origin: bottom center;
        transition: .5s cubic-bezier(.165, .84, .44, 1);
        opacity: 0;
        .new-product {
          display: flex;
          padding: .1rem;
          width: 4.2rem;
          background-color: #FFF;
          border-radius: .1rem;
          .new-product-cover {
            position: relative;
            flex-shrink: 0;
            display: block;
            width: 1.2rem;
            height: 1.2rem;
            border-radius: .1rem;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .new-product-cover-tag {
              position: absolute;
              top: 0;
              left: 0;
              padding: 0 .08rem;
              line-height: .32rem;
              font-size: .24rem;
              color: #FFF;
              background-color: rgba(0, 0, 0, .4);
              border-bottom-right-radius: .05rem;
            }
          }
          .new-product-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: .12rem;
            .new-product-info-name {
              line-height: .32rem;
              font-size: .24rem;
              color: #333333;
            }
            .new-product-info-footer {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .new-product-info-price {
                font-size: .34rem;
                color: #FF3E28;
              }
            }
          }
        }
        .new-product-triangle {
          margin-top: -.02rem;
          width: 0px;
          height: 0px;
          border: .15rem solid #FFF;
          border-bottom-color: transparent;
          border-left-color: transparent;
          border-right-color: transparent
        }
      }
      .new-product-wrapper.show-product {
        transform: scale(1);
        opacity: 1;
      }
      .bubble-click-count {
        position: absolute;
        top: -.15rem;
        left: 50%;
        display: flex;
        align-items: center;
        height: .28rem;
        transform: translateX(-50%);
        padding: 0 .1rem;
        text-align: center;
        background-color: #FFF;
        border-radius: .3rem;
        pointer-events: none;
        font-size: .2rem !important;
        color: red;
      }
    }
  }
  .inner-flex.inner-flex-light {
    background-color: #EEEEEE;
    .input-container {
      display: flex;
      align-items: center;
      padding: 0 .2rem;
      margin-right: .2rem;
      border-radius: .1rem;
      height: 100%;
      flex: 1;
    }
  }
  
  .customer-btn {
    position: absolute;
    right: .24rem;
    top: -.98rem;
    width: .75rem;
    height: .88rem;
  }

  .safe-area-light {
    background-color: #EEE;
  }
  .safe-area-dark {
    background-color: #8308B7;
    // background-color: #320372;
  }
}
</style>

<style lang="scss">
.bottom-fixed {
  .van-button--normal {
    height: .76rem;
  }

  #like-bubble-container {
    position: absolute;
    left: -.55rem;
    top: -3.7rem;
    pointer-events: none;
  }
}
</style>
